import { Controller } from "stimulus";
import Glide from "@glidejs/glide";

export default class extends Controller {
  static targets = ["currentSlide", "slider"]

  onModalOpened() {
    if (this.glide) return;

    this.glide = new Glide(this.sliderTarget, { 
      type: 'carousel', 
      perView: 1, 
      gap: 20, 
      animationDuration: 150,
      swipeThreshold: 5,
      dragThreshold: 5
    }).mount();
    this.glide.on(["run"], () => {
      this.updateSlideNumbers();
    });
  }

  updateSlideNumbers() {
    const currentSlideNumber = this.glide.index + 1;
    this.currentSlideTargets.forEach((target) => {
      target.textContent = this.pad(currentSlideNumber);
    })
  }

  pad(number) {
    return number.toString().padStart(2, '0');
  }
}
